module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown dropdown-extended dropdown-inbox",
    attrs: {
      "id": "header_inbox_bar"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-close-others": "true"
    }
  }, [_c('i', {
    staticClass: "icon-bubble"
  }), _vm._v(" "), _c('span', {
    staticClass: "badge badge-warning"
  }, [_vm._v(_vm._s(_vm.user.hasOwnProperty('alerts') ? _vm.user.alerts.count : 0))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "external"
  }, [_c('h3', [_vm._v("You have\n        "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.user.hasOwnProperty('alerts') ? _vm.user.alerts.count : 0))]), _vm._v(" new message" + _vm._s(_vm.user.hasOwnProperty('alerts') && (_vm.user.alerts.count > 1 || _vm.user.alerts.count == 0) ? 's' : '') + ".\n      ")])]), _vm._v(" "), (_vm.user.hasOwnProperty('alerts')) ? _c('li', [_c('ul', {
    staticClass: "dropdown-menu-list scroller",
    staticStyle: {
      "max-height": "308px",
      "overflow": "auto"
    },
    attrs: {
      "data-handle-color": "#637283"
    }
  }, [_vm._l((_vm.user.alerts.sms_alerts), function(alert) {
    return _c('li', [_c('router-link', {
      staticClass: "clearfix",
      attrs: {
        "to": {
          name: 'Messages',
          params: {
            id: alert.participantId
          }
        }
      }
    }, [_c('span', {
      staticClass: "photo"
    }, [_c('avatar', {
      staticClass: "avatar",
      attrs: {
        "username": alert.fullName,
        "src": alert.avatar,
        "size": 40,
        "rounded": true,
        "color": "#d09f23",
        "backgroundColor": "#eef1f5"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "subject"
    }, [_c('span', {
      staticClass: "from"
    }, [_vm._v(_vm._s(alert.fullName))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDateByArrival")(alert.createdAt.date)))])]), _vm._v(" "), _c('span', {
      staticClass: "message"
    }, [_vm._v(" You have "), _c('b', [_vm._v(_vm._s(alert.count))]), _vm._v(" new message" + _vm._s((alert.count > 1 || alert.count == 0) ? 's' : '') + ".")])])], 1)
  }), _vm._v(" "), (_vm.user.alerts.referral_alerts.count) ? _c('li', [_c('router-link', {
    staticClass: "clearfix",
    attrs: {
      "to": {
        name: 'Referral Dashboard'
      }
    }
  }, [_c('span', {
    staticClass: "photo"
  }, [_c('span', {
    staticClass: "avatar avatar-fa"
  }, [_c('i', {
    staticClass: "icon-users"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "subject"
  }, [_c('span', {
    staticClass: "from"
  }, [_vm._v(_vm._s(_vm.user.alerts.referral_alerts.title))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("formatDateByArrival")(_vm.user.alerts.referral_alerts.createdAt.date)))])]), _vm._v(" "), _c('span', {
    staticClass: "message"
  }, [_vm._v(" You have "), _c('b', [_vm._v(_vm._s(_vm.user.alerts.referral_alerts.count))]), _vm._v(" new referral/application" + _vm._s((_vm.user.alerts.referral_alerts.count > 1) ? 's' : '') + ".")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.alerts.assigned_case_manager), function(alert) {
    return _c('li', [_c('router-link', {
      staticClass: "clearfix",
      attrs: {
        "to": {
          name: 'Dashboard Participant',
          params: {
            id: alert.participantId
          }
        }
      }
    }, [_c('span', {
      staticClass: "photo"
    }, [_c('avatar', {
      staticClass: "avatar",
      attrs: {
        "username": alert.fullName,
        "src": alert.avatar,
        "size": 40,
        "rounded": true,
        "color": "#d09f23",
        "backgroundColor": "#eef1f5"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "subject"
    }, [_c('span', {
      staticClass: "from"
    }, [_vm._v(_vm._s(alert.title))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDateByArrival")(alert.createdAt.date)))])]), _vm._v(" "), _c('span', {
      staticClass: "message"
    }, [_vm._v(_vm._s(alert.body))])])], 1)
  }), _vm._v(" "), _vm._l((_vm.user.alerts.shared_form_completed), function(alert) {
    return _c('li', [_c('router-link', {
      staticClass: "clearfix",
      attrs: {
        "to": {
          name: 'Dashboard Participant',
          params: {
            id: alert.participantId
          }
        }
      }
    }, [_c('span', {
      staticClass: "photo"
    }, [_c('avatar', {
      staticClass: "avatar",
      attrs: {
        "username": alert.fullName,
        "src": alert.avatar,
        "size": 40,
        "rounded": true,
        "color": "#d09f23",
        "backgroundColor": "#eef1f5"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "subject"
    }, [_c('span', {
      staticClass: "from"
    }, [_vm._v(_vm._s(alert.title))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDateByArrival")(alert.createdAt.date)))])]), _vm._v(" "), _c('span', {
      staticClass: "message"
    }, [_vm._v("You have "), _c('b', [_vm._v(_vm._s(alert.count))]), _vm._v(" new submission" + _vm._s((alert.count > 1) ? 's' : '') + ".")])])], 1)
  }), _vm._v(" "), _vm._l((_vm.user.alerts.shared_form_failed), function(alert) {
    return _c('li', [_c('router-link', {
      staticClass: "clearfix",
      attrs: {
        "to": {
          name: 'Dashboard Participant',
          params: {
            id: alert.participantId
          }
        }
      }
    }, [_c('span', {
      staticClass: "photo"
    }, [_c('avatar', {
      staticClass: "avatar",
      attrs: {
        "username": alert.fullName,
        "src": alert.avatar,
        "size": 40,
        "rounded": true,
        "color": "#d09f23",
        "backgroundColor": "#eef1f5"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "subject"
    }, [_c('span', {
      staticClass: "from"
    }, [_vm._v(_vm._s(alert.title))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDateByArrival")(alert.createdAt.date)))])]), _vm._v(" "), _c('span', {
      staticClass: "message"
    }, [_vm._v("You have "), _c('b', [_vm._v(_vm._s(alert.count))]), _vm._v(" new exception" + _vm._s((alert.count > 1) ? 's' : '') + ".")])])], 1)
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a62165","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Inbox.vue
// module id = 1589
// module chunks = 1